export * from './orderLine.types';

export const TemporaryOrderNoteIdPrefix = 'temporary-order-note-';
